<template>
    <div class="" style="margin: 0 26px;margin-bottom: 0!important;">
        <div class="out_box">
            <div class="inner_box" v-loading='loading' :style="'height:'+heights">
                <div class="tit_box">平台公告</div>
                <div class="list_box" :style="'height:'+listheights">
                    <div class="items u-f u-ac u-jsb" v-for="(x,index) in xx_list" :key="index" @click="opdetail(x)">
                        <div>{{index+1}}、 {{x.Activity.activity_title}}</div>
                        <div>{{x.create_time}}</div>
                    </div>
                </div>
                <div class="u-f u-ac u-ajc ">
                    <div>
                        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                            layout="total, prev, pager, next, jumper" :total="count">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="公告详情" :visible.sync="dialogs" width="40%" top="20px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='detailloading' :style="'height:'+detailheights">
                <div class="cons" v-html="xxdatasContent"></div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {

                loading: false,
                heights: null,
                listheights: null,
                detailheights: null,
                dialogs: false,
                count: 0,
                currentPage: 1,
                xx_list: [],
                xxdatasContent: '',
                detailloading: false


            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                that.heights = window.innerHeight - 195 + 'px'
                that.listheights = window.innerHeight - 350 + 'px'
                that.detailheights = window.innerHeight - 220 + 'px'
                window.onresize = () => {
                    that.heights = window.innerHeight - 195 + 'px'
                    that.listheights = window.innerHeight - 350 + 'px'
                    that.detailheights = window.innerHeight - 220 + 'px'

                }
            },
            begin() {
                this.search()
            },
            search() {
                let that = this
                that.loading = true
                this.axios.post('/admin/SystemActivity/index', {
                    page: this.currentPage,
                    page_count: 10
                }, {
                    token: true
                }).then(res => {
                    that.loading = false
                    if (res.data.code == 200) {
                        this.xx_list = res.data.data.list
                        this.count = res.data.data.count
                    }
                })
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            opdetail(x) {
                this.dialogs = true
                this.detailloading = true
                this.axios.post('/admin/SystemActivity/read', {
                    id: x.data_id,
                    source: 2
                }, {
                    token: true
                }).then(res => {
                    this.detailloading = false
                    if (res.data.code == 200) {
                        this.xxdatasContent = res.data.data.activity_content
                    }

                })
            }




        },

    };
</script>
<style lang="scss" scoped>
    .out_box {
        // padding: 30px;
        background-color: #F8F9FA;

        .inner_box {
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0 0 4px 0 rgba($color: #a3a3a3, $alpha: .1);
            padding: 25px 30px;

            .tit_box {
                font-size: 20px;
                color: #000;
                margin-bottom: 20px;

            }

            .list_box {
                .items {
                    cursor: pointer;
                }
            }
        }

    }

    .dialog-ibox-content {
        overflow: auto;
    }

    .cons {
        /deep/img {
            max-width: 100% !important;
        }
    }
    /deep/.el-dialog__title{
        font-size: 16px !important;
    }
</style>